import React, { Component } from 'react';
import { Form, Button, Checkbox, message } from 'antd';
import axios from 'axios';

import './style.css';

class EmailForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			subscribed: false,
			error: null,
		};
	}

	handleSubmit = async (values) => {
		if (values.bl_botField) {
			console.warn('Spam detected');
			message.error('Spam detected. Submission rejected.');
			return;
		}

		try {
			this.setState({ loading: true, error: null });

			const proxyUrl = `${window.location.origin}/wp-content/plugins/wp-local-rankflux/hubspot-proxy.php`;
			const rankfluxSubscriptionType = (values.bl_frequency || []).join(";");

			console.log("Step 1: Checking if contact exists for email:", values.bl_email);

			let contactId = null;

			// Step 1: Search for the contact by email
			try {
				const searchResponse = await axios.post(
					`${proxyUrl}?url=${encodeURIComponent('https://api.hubapi.com/crm/v3/objects/contacts/search')}`,
					{
						filterGroups: [
							{
								filters: [
									{
										propertyName: "email",
										operator: "EQ",
										value: values.bl_email,
									},
								],
							},
						],
						properties: ["id"],
					}
				);

				if (searchResponse.data.total > 0) {
					contactId = searchResponse.data.results[0].id;
					console.log(`Contact exists. Updating Contact ID: ${contactId}`);
				}
			} catch (error) {
				console.warn("Contact search failed or does not exist. Proceeding to create a new contact.");
			}

			const contactData = {
				properties: {
					email: values.bl_email,
					firstname: values.bl_firstname,
					rankflux_subscription_type: rankfluxSubscriptionType,
					hs_marketable_status: "true",
				},
			};

			if (contactId) {
				// Step 2: If contact exists, update it
				await axios.patch(
					`${proxyUrl}?url=${encodeURIComponent(`https://api.hubapi.com/crm/v3/objects/contacts/${contactId}`)}`,
					contactData
				);
				message.warning("You were already subscribed. Your preferences have been updated.");
			} else {
				// Step 3: If no contact is found, create a new one
				console.log("Creating a new contact:", values.bl_email);
				const contactResponse = await axios.post(
					`${proxyUrl}?url=${encodeURIComponent('https://api.hubapi.com/crm/v3/objects/contacts')}`,
					contactData
				);
				contactId = contactResponse.data.id;
				message.success("Subscription successful!");
			}

			// Step 4: Add the contact to List 1356 using the CORRECT method
			if (contactId) {
				console.log(`Adding contact ID ${contactId} to [RankFlux] Subscribers List (ID: 1356)`);

				await axios.put(
					`${proxyUrl}?url=${encodeURIComponent(`https://api.hubapi.com/crm/v3/lists/1356/memberships/add-and-remove`)}`,
					{
						recordIdsToAdd: [contactId],
						recordIdsToRemove: [],
					}
				);
				// console.log(`Successfully added contact to List 1356`);
			}

			this.setState({ loading: false, subscribed: true });

		} catch (error) {
			console.error("Error occurred during subscription process:", error.response?.data || error.message);
			this.setState({ loading: false, error: error.response?.data?.message || 'Subscription failed. Please try again.' });
			message.error(error.response?.data?.message || 'Subscription failed. Please try again.');
		}
	};



	render() {
		const { loading, subscribed, error } = this.state;

		return (
			<div className="rf-email-form">
				<div class="heading">
					<h5>
						Be the first to hear about local algorithm volatility. Subscribe to <span className="bold">Local RankFlux email alerts</span>{' '}
						today!
					</h5>

					{error && <div className="rf-error-message">{error}</div>}
				</div>

				<Form onFinish={this.handleSubmit}>
					<div className="rf-email-wrapper">
						<Form.Item
							name="bl_email"
							rules={[
								{
									required: true,
									message: 'Please enter your email address',
								},
							]}
						>
							<input
								className="rf-email-input"
								type="email"
								placeholder="Email address"
							/>
						</Form.Item>
						<Form.Item
							name="bl_firstname"
							rules={[
								{
									required: true,
									message: 'Please enter your first name',
								},
							]}
						>
							<input
								className="rf-email-input"
								type="text"
								placeholder="First name"
							/>
						</Form.Item>

						<Form.Item
							name="bl_frequency"
							initialValue={[]}
							className="rf-select-frequency"
							label="Email frequency"
							rules={[
								{
									required: true,
									message: 'Please select an Email frequency',
								},
							]}
						>
							<Checkbox.Group className="rf-email-checkbox">
								<Checkbox value="Weekly">Weekly</Checkbox>
								<Checkbox value="Daily">Daily</Checkbox>
								<Checkbox value="Urgent">Urgent</Checkbox>
							</Checkbox.Group>
						</Form.Item>

						<Form.Item name="bl_botField" style={{ display: 'none' }}>
							<input type="text" placeholder="Leave this empty" />
						</Form.Item>
					</div>

					<Form.Item className="rf-email-button">
						<Button
							className="button rf-subscribe-btn blue"
							type="primary"
							htmlType="submit"
							disabled={loading || subscribed}
						>
							{loading ? 'Subscribing...' : subscribed ? 'Subscribed' : 'Subscribe'}
						</Button>
					</Form.Item>
				</Form>
			</div>
		);
	}
}

export default EmailForm;
